import { Pipe, PipeTransform } from '@angular/core';
import type { ApplicationAccessControlRatePlanFindInterface } from '@zaoblako/shared/modules/security/dtos/application/access-control/application-access-control-rate-plan-find.dto';

@Pipe({
  name: 'translateModules',
  standalone: true
})
export class TranslateModulesPipe implements PipeTransform {
  public transform(modules: ApplicationAccessControlRatePlanFindInterface): string[] {
    return Object
      .values(modules || {})
      .filter((module) => module.enabled)
      .map((module) => module.displayName)
  }
}
